import React from 'react';
import { styled } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
}));

const Main = props => {
  const { children } = props;

  return (
    <Root>
      <CssBaseline />
      {children}
    </Root>
  );
};

export default Main;
